import styled from "styled-components";

interface TickRadioWrapperProps {
  isSelected: boolean;
}

export const TickRadioWrapper = styled.div<TickRadioWrapperProps>`
  cursor: pointer;
  user-select: none;
  width: 100%;
`;

export const HiddenRadioInput = styled.input`
  display: none;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  width: 100%;
`;

export const RadioCircle = styled.span<{ isSelected: boolean }>`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid
    ${(props) => (props.isSelected ? "var(--tm-accent-color)" : "#999")};
  background: ${(props) =>
    props.isSelected ? "var(--tm-accent-color)" : "#fff"};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  transition: all 0.2s ease;

  ${(props) =>
    props.isSelected &&
    `
    &::after {
      content: "";
      display: block;
      width: 4px;
      height: 8px;
      border: solid #fff;
      border-width: 0 1.5px 1.5px 0;
      transform: rotate(45deg);
      margin-top: -2px;
    }
  `}
`;

export const RadioLabelContent = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;
